import React from 'react';
import { Link } from 'react-router-dom';
import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Footer from '../Footer/Footer';
import useLore from '../../hooks/useLore';

import place5 from '../../assets/img/place5.jpg';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

export default function Lore() {
  const { allLore, isLoading } = useLore();

  if (isLoading) {
    return null;
  }

  const heroimg = {
    background: 'url(' + place5 + ') no-repeat center center',
    backgroundSize: 'cover',
  };

  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="media"
    >
      <Helmet>
        <title>Lore - DuskBreakers</title>
        <meta
          name="description"
          content="Explore the universe of DuskBreakers and learn more about life as a Breaker."
        />
      </Helmet>

      <section
        className="
        d-flex
        align-items-center
        justify-content-center
        has-bg
      "
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h1 className="mb-5">Lore</h1>
            </div>
          </div>
        </div>

        <div className="is-bg fade-hero" style={heroimg} />
      </section>

      <section className="mt-n6 mt-lg-n7">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col">
              <div className="posts__container">
                <div className="row d-flex g-4">
                  {allLore.map((lore) => {
                    const { id, slug, title, imageUrl } = lore;

                    return (
                      <div className="col-md-4" key={slug}>
                        <div className="card linkcard m-0">
                          <Link className="posts__post noline" to={`/lore/${id}/${slug}`}>
                            {imageUrl && (
                              <LazyLoadImage
                                className="img-fluid"
                                alt={title}
                                src={imageUrl}
                                effect="opacity"
                              />
                            )}

                            <div className="card-body">
                              <span>{title}</span>
                            </div>
                          </Link>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </m.main>
  );
}
